import { Lead } from "@kanda-libs/ks-frontend-services";
import { createSelector } from "@reduxjs/toolkit";
import { selectors } from "store";

// Select leads as an object, with status as the key
const getLeadsByStatus = createSelector(
  selectors.lead.getEntitiesAsArray,
  (leads) => {
    const leadsByStatus = leads.reduce((acc, lead) => {
      const { status } = lead;
      acc[status] = [...(acc[status] || []), lead];
      return acc;
    }, {} as Record<Lead["status"], Lead[]>);
    return leadsByStatus;
  }
);

const getLeadStatuses = createSelector(
  getLeadsByStatus,
  (leadsByStatus) => Object.keys(leadsByStatus) as Lead["status"][]
);

const getLeadJobs = createSelector(
  selectors.lead.getEntity,
  selectors.job.getEntitiesAsArray,
  (lead, jobs) => {
    return jobs.filter((job) => job?.quoted_to == lead?.id);
  }
);

const leadSelectors = {
  ...selectors.lead,
  getLeadStatuses,
  getLeadsByStatus,
  getLeadJobs,
};

export default leadSelectors;
